import { ItiLink as Link } from 'components';
import DataTable, { DataTableColumn } from 'components/tables/data-table';
import { useAuth } from 'contexts';
import { FC, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPaginated } from 'services';
import { downloadCsv } from 'services/download-csv';
import { Role } from 'types';
import { FilterOperator, FilterState, LogicalOperator } from 'utils';

export const CustomersTab: FC = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const [showDeleted, setShowDeleted] = useState<boolean>(true);

  const columns: DataTableColumn[] = [
    {
      field: 'id',
      label: 'Record',
      width: 80,
      renderCell: value => <Link to={`/settings/customers/${value}`}>{value}</Link>
    },
    { field: 'name', label: 'Name', width: 80 },
    { field: 'code', label: 'Code', width: 80 },
    {
      field: 'deleted',
      label: 'STATUS',
      type: 'boolean',
      width: 80,
      getValueLabel: value => (value ? 'DEACTIVATED' : 'ACTIVE')
    },
    {
      field: 'ediEnabled',
      label: 'EDI',
      type: 'boolean',
      width: 80,
      getValueLabel: value => (value ? 'ENABLED' : 'DISABLED')
    },
    {
      field: 'emailEnabled',
      label: 'EMAIL',
      type: 'boolean',
      width: 80,
      getValueLabel: value => (value ? 'ENABLED' : 'DISABLED')
    }
  ];

  const initialFilters: FilterState = useMemo(() => {
    return {
      logicalOperator: LogicalOperator.AND,
      filters: showDeleted ? [] : [{ field: 'deleted', filterOperator: FilterOperator.EQUALS, value: false }]
    };
  }, [showDeleted]);

  return (
    <div id="customer-table">
      {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
        <div className="flex-fill d-flex justify-content-end g-3">
          <button
            id="create-customer"
            className="btn-primary"
            onClick={() => navigate('/settings/customers/new')}
            data-cy="new-customer-button"
          >
            NEW CUSTOMER
          </button>
        </div>
      )}
      <DataTable
        key={initialFilters.filters.length}
        fetchData={fetchPaginated('customers/page')}
        fetchCsv={downloadCsv('customers')}
        initialFilters={initialFilters}
        initialPage={{ sortField: 'id', sortDirection: 'asc', pageSize: 25 }}
        initialColumns={columns.map(c => ({ field: c.field, width: c.width }))}
        columns={columns}
        filterByLocation
        searchAdornment={
          <div className="d-flex align-items-center g-3">
            <label className="text-info-dark">SHOW DEACTIVATED</label>
            <label className="switch">
              <input type="checkbox" checked={showDeleted === true} onChange={e => setShowDeleted(e.target.checked)} />
              <span className="slider round" />
            </label>
          </div>
        }
      />
    </div>
  );
};
